export default "__VITE_ASSET__8d66243c__"